module.exports = __webpack_public_path__ + "img/icon-calendar.9d5c4a35.svg";